/* ==========================================================================
   Statement Section — vanilla JS
   Handles optional fade-in-on-scroll animation via IntersectionObserver.
   ========================================================================== */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var enableAnimation = section.dataset.enableAnimation === 'true';
    if (!enableAnimation) return;

    section.classList.add('statement--animate');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('statement--in-view');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('statement--in-view');
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }

  function initAll() {
    document.querySelectorAll('[data-statement]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-statement]');
    if (section) {
      section.dataset.initialized = 'false';
      initSection(section);
    }
  });
})();